import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from 'assets/locales/de.json';
import en from 'assets/locales/en.json';

export const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

export const defaultNS = 'translation';

const initializei18n = async () => {
  try {
    await use(initReactI18next).init({
      resources,
      defaultNS,
      lng: 'en',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    });
  } catch (error) {
    console.log('Failed to initialize i18n:', error);
  }
};

initializei18n();
